import { ChevronDown } from 'lucide-react';

interface SpeedControlProps {
  speed: number;
  onSpeedChange: (speed: number) => void;
}

export function SpeedControl({ speed, onSpeedChange }: SpeedControlProps) {
  const speeds = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

  return (
    <div className="speed-control">
      <select
        value={speed}
        onChange={(e) => onSpeedChange(Number(e.target.value))}
        className="tw-w-[5.5rem] tw-h-10 speed-select"
        title="Playback Speed"
      >
        {speeds.map((speed) => (
          <option key={speed} value={speed}>
            {speed === 1 ? 'Normal' : `${speed}x`}
          </option>
        ))}
      </select>
      <ChevronDown size={16} className="speed-icon" />
    </div>
  );
}